import { Injectable } from '@nestjs/common';
import { ZoneMaster } from '../zone-master.entity';
import { ZoneMasterDTO } from './zone.dto';

@Injectable()
export class ZoneAdapter {
  /**
   *
   * @param ZoneMasterDTO
   * @returns Zone entity
   */
  public convertDtoToEntity(  zoneMasterDTO: ZoneMasterDTO,  isUpdate: boolean = false ): ZoneMaster {
    const zone = new ZoneMaster();
    zone.zoneId=zoneMasterDTO.zoneId;
    zone.zoneCode=zoneMasterDTO.zoneCode;
    zone.zoneName=zoneMasterDTO.zoneName;
    zone.plantId=zoneMasterDTO.plantId;
    zone.isActive=zoneMasterDTO.isActive==undefined?true:zoneMasterDTO.isActive;
    if (isUpdate) {
      zone.updatedUser = zoneMasterDTO.updatedUser;
    } else {
      zone.isActive = true;
      zone.createdUser = zoneMasterDTO.createdUser;
    }
   return zone;
  }
  public convertEntityToDto(zoneObject: ZoneMaster): ZoneMasterDTO {
    const zoneMasterDTO= new ZoneMasterDTO;
    zoneMasterDTO.zoneId = zoneObject.zoneId;
    zoneMasterDTO.zoneCode = zoneObject.zoneCode;
    zoneMasterDTO.zoneName = zoneObject.zoneName;
    zoneMasterDTO.plantId = zoneObject.plantId;
    zoneMasterDTO.isActive = zoneObject.isActive;
    zoneMasterDTO.createdAt = zoneObject.createdAt;
    zoneMasterDTO.updatedAt = zoneObject.updatedAt;
    zoneMasterDTO.createdUser = zoneObject.createdUser;
    zoneMasterDTO.updatedUser = zoneObject.updatedUser;
    zoneMasterDTO.versionFlag = zoneObject.versionFlag;
    return zoneMasterDTO;
  }
}
